export default __webpack_public_path__ + "static/media/Sriharsh.fb87fd63.png";